import type { CallStatus } from '../../types';

/**
 * Map Voice SDK transport statuses to call UI states.
 * Unknown/non-authoritative transport events should not reset ACD contact state.
 */
export function mapVoiceCallStatus(status: string | undefined): CallStatus | null {
  if (!status) return null;

  const statusLower = status.toLowerCase();
  if (statusLower === 'callholdstatechanged') return null;
  if (statusLower === 'callterminated' || statusLower === 'callfailed') return 'disconnected';
  if (statusLower === 'connecting' || statusLower === 'outgoingcall') return 'connecting';
  if (statusLower === 'incomingcall' || statusLower.includes('ring')) return 'ringing';
  if (statusLower === 'callconfirmed' || statusLower === 'callshowstreams') return 'active';
  if (
    statusLower.includes('active') ||
    statusLower.includes('connected') ||
    statusLower.includes('confirmed') ||
    statusLower.includes('stream')
  ) {
    return 'active';
  }
  if (statusLower.includes('hold')) return 'holding';
  if (
    statusLower.includes('disconnect') ||
    statusLower.includes('end') ||
    statusLower.includes('terminat') ||
    statusLower.includes('fail')
  ) {
    return 'disconnected';
  }

  return null;
}
